import React, { Component } from 'react';
import styled from 'styled-components';
import { changeLocation } from 'api/Location';

import Auth from '../../../routes/Auth';
import OnboardingLayout from './OnboardingLayout';
import { getNextOnboardingStep } from './onboardingRouting';

const Heading = styled.h1`
  margin: 16px 0 42px;
  font-family: 'Mukta Vaani', 'Mukta Mahee', sans-serif;
  font-size: 24px;
  line-height: 60px;
  font-weight: 700;
  color: #2F4166;
  text-align: center;
`;

const OptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 22px;
  min-height: 101px;
  background: #FFFFFF;
  border: ${p => p.selected ? '2px solid #2F4166' : '2px solid transparent'};
  border-radius: 10px;
  padding: 16px 20px;
  margin-bottom: 24px;
  cursor: pointer;
  transition: border-color 160ms ease, box-shadow 160ms ease;
  box-shadow: ${p => p.selected ? '0 4px 12px rgba(47, 65, 102, 0.15)' : 'none'};

  &:hover { border-color: ${p => p.selected ? '#2F4166' : 'rgba(47, 65, 102, 0.3)'}; }
`;

const OptionTag = styled.div`
  flex: 0 0 auto;
  min-width: 105px;
  height: 40px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #D5D9DD;
  border-radius: 5px;
  background: #FFFFFF;
  font-family: 'Mukta Vaani', 'Mukta Mahee', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #2F4166;
`;

const OptionText = styled.div`
  flex: 1;
  font-family: 'Mukta Vaani', 'Mukta Mahee', sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: rgba(0, 27, 59, 0.94);
`;

const OPTIONS = [
  {
    id: 'demo',
    tag: 'Demo',
    description: 'Walk through a demo of the exercise.',
  },
  {
    id: 'setup',
    tag: 'Setup',
    description: 'Set up simulation for my course.',
  },
];

class PathChoice extends Component {
  state = { selected: null };

  handleSelect = (id) => {
    this.setState({ selected: id });
  };

  handleContinue = () => {
    const { selected } = this.state;
    if (!selected) return;

    if (selected === 'demo') {
      changeLocation('/demo');
      return;
    }
    // Route via utility so we skip simulation-selection or
    // team-evaluation-survey if the course already has them.
    const setup = this.props.onboardingSetup || { hasGame: false, hasSurvey: false };
    const user = Auth.getUser();
    const onboardComplete = !!(user && user.onboard !== 0);
    changeLocation(getNextOnboardingStep('path-choice', {
      hasGame: setup.hasGame,
      hasSurvey: setup.hasSurvey,
      onboardComplete,
    }));
  };

  render() {
    const { selected } = this.state;

    return (
      <OnboardingLayout
        progressStep={1}
        progressTotal={4}
        buttonLabel="Continue"
        buttonDisabled={!selected}
        onButtonClick={this.handleContinue}
      >
        <Heading>Where would you like to start?</Heading>
        {OPTIONS.map(opt => (
          <OptionRow
            key={opt.id}
            selected={selected === opt.id}
            onClick={() => this.handleSelect(opt.id)}
          >
            <OptionTag>{opt.tag}</OptionTag>
            <OptionText>{opt.description}</OptionText>
          </OptionRow>
        ))}
      </OnboardingLayout>
    );
  }
}

export default PathChoice;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/PathChoice.js